export enum FilterOperator {
    EQUAL = "EQUALS",
    NOT_EQUAL = "NOT_EQUALS",
    MATCH = "MATCH",
    EXIST = "EXIST",
    GREATER_THAN = "GREATER_THAN",
    LESS_THAN = "LESS_THAN",
    IN = "IN",
    NOT_IN = "NOT_IN",
}

export enum FilterPathType {
    STRING = "STRING",
    KEYWORD = "KEYWORD",
    NUMBER = "NUMBER",
    DATE = "DATE",
    BOOLEAN = "BOOLEAN",
}

export enum FilterLogicOperator {
    AND = "AND",
    OR = "OR",
}

export const DISPLAY_TO_FILTER_OPERATOR: Record<string, FilterOperator> = {
    is: FilterOperator.EQUAL,
    isNot: FilterOperator.NOT_EQUAL,
    contains: FilterOperator.MATCH,
    doesNotContain: FilterOperator.NOT_IN,
    exists: FilterOperator.EXIST,
    greaterThan: FilterOperator.GREATER_THAN,
    lessThan: FilterOperator.LESS_THAN,
};

export enum RiskLevel {
    HIGH = "HIGH",
    MEDIUM = "MEDIUM",
    LOW = "LOW",
    NOT_AVAILABLE = "NOT_AVAILABLE",
}

export const TEXT_FILTER_OPERATOR_KEYS = ["is", "isNot", "contains", "doesNotContain", "exists"];

export const NUMERIC_FILTER_OPERATOR_KEYS = ["is", "isNot", "greaterThan", "lessThan", "exists"];
